import { combineReducers } from 'redux';
import authReducer from './reducerAuth';

export default combineReducers({
  auth: authReducer
});
